import CrmCharts from "../../components/control/charts";

const CrmChartsPage = () => {
  return (
    <CrmCharts />
  );
};

export default CrmChartsPage;
